// supabase.js
import { createClient } from '@supabase/supabase-js';

// detectSessionInUrl is off because AuthAction.jsx (password reset / email
// verification links) needs to read `type` out of the URL hash itself before
// deciding what to show - the SDK's own auto-detect strips the hash first if
// left on, so by the time that page's effect runs there's nothing left to
// read. Same race already found and fixed in pws-con's admin auth flow.
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { auth: { detectSessionInUrl: false } }
);
